/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-duplicate-props */
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  CircularProgress,
  TextField,
  Drawer,
} from '@mui/material';
import {
  AccessTimeRounded,
  ArrowBackRounded,
  CloseRounded,
  NotificationsNoneRounded,
  PeopleOutlineOutlined,
  SearchRounded,
} from '@mui/icons-material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import io from 'socket.io-client';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Elements from '../../../Elements';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {
  formatNum, formatNumToCurrency, formatVolumeToInt, isB2C, isSubscriber, onlyNumbers,
} from '../../../../Utils/helpers';
import {
  addReminder,
  addToCart,
  addToWatchlist,
  checkoutItems,
  checkoutItemWinner,
  getCart,
  getItemDetails,
  unsellProduct,
} from '../../../../Redux/Models/market';
import { getUserData } from '../../../../Utils/storages';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import MarketIcons from '../../../../Configs/marketIcons';
import Colors from '../../../../Configs/colors';
import dummy from '../../../../Configs/dummy';

const socketUrl = process.env.REACT_APP_SOCKET;
const socket = io(socketUrl, { transports: ['websocket'] });

export default function ProductDetails(props) {
  const {
    selectedItem: selected, isLoading,
  } = props;

  const selectedItem = selected.box || selected.item || {};
  const [param, setParam] = useSearchParams();
  const type = param.get('type') || 'item';

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { productId } = useParams();
  const user = getUserData();

  const userId = user.id;

  useEffect(() => {
    if (!productId) {
      navigate(ROUTES.market(), 'replace');
    } else {
      dispatch(getItemDetails(userId, productId, type));
      dispatch(getCart(userId));
    }
  }, [productId]);

  if (selectedItem.id && !isLoading) {
    return (
      <Details {...props} selectedItem={selectedItem} />
    );
  }
  return (
    <div className="center mt-3">
      <CircularProgress color="inherit" />
    </div>
  );
}

function Details({
  classes,
  selectedItem,
  checkedOut,
  message,
  error,
  isLoading,
  addedToCart,
  newWatchlist,
  loadingWatchlist,
  cart,
  canceled,
  detailsError,
}) {
  const userData = getUserData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { productId } = useParams();
  const { openAlert } = useContext(AlertContext);
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);
  const user = getUserData();
  const B2C = isB2C();
  const subscriber = isSubscriber();
  const { t } = useTranslation();

  const { auction = {} } = selectedItem;

  const bidPrice = selectedItem.sale_type === 'Bid Price';
  const fixedPrice = selectedItem.sale_type === 'Fixed Price';

  const volume = formatVolumeToInt(selectedItem?.volume);

  const quota = userData.quota || 0;

  const [connected, setConnected] = useState(false);

  const [bidField, setBidField] = useState(0);
  const [latestBid, setLatestBid] = useState([]);
  const [maxBid, setMaxBid] = useState(0);
  const [cartLoad, setCartLoad] = useState(false);
  const [openOffer, setOpenOffer] = useState(false);
  const [openWatchlist, setOpenWatchlist] = useState(false);
  const [wantToBuy, setWantToBuy] = useState(false);

  const userId = user.id;
  const room = auction.id;

  useEffect(() => {
    if (!connected && bidPrice) {
      // console.log('connecting', { userId, room });
      socket.emit('join', { userId, room });
      setConnected(true);
    }

    // return () => {
    //   socket.close();
    //   // eslint-disable-next-line no-console
    //   console.log('socket closed');
    // };
  });

  socket.on('max-bid', (logs) => {
    if (logs.length) {
      setMaxBid(logs[0].price + maxBid);
    } else {
      setMaxBid(selectedItem.auction?.open_price || 0);
    }
  });

  // socket.on('message', () => {
  //   socket.on('roomData', (data) => {
  //     console.log('roomData', data);
  //   });
  // });

  socket.on('error', (err) => {
    openAlert({
      severity: 'error',
      message: err,
      open: true,
    });
  });

  socket.on('list-offer', (logs) => {
    setLatestBid(logs);
  });

  useEffect(() => {
    setBidField(maxBid + 1);
  }, [maxBid]);

  const toggleOpenOffer = () => {
    setOpenOffer(!openOffer);
  };

  const toggleOpenWatchlist = () => {
    setOpenWatchlist(!openWatchlist);
  };

  const toggleWantToBuy = () => {
    setWantToBuy(!wantToBuy);
  };

  const postBid = async () => {
    if (!subscriber) {
      openConfirmation({
        handleAgree: () => {
          navigate(ROUTES.subscription());
        },
        title: 'Explore rare wines, bid now!',
        desc: 'Subscribe to unlock the experience',
        confirmText: 'Subscribe now',
      });
      return;
    }

    if (Number(bidField || 0) > maxBid) {
      setCartLoad(true);
      await socket.emit('post-bid', { bid: Number(bidField), room, userId });
      setCartLoad(false);
      openAlert({
        title: 'Your bid placed',
        message: 'Please wait for further bid information!',
      });
      toggleOpenOffer();
    }
  };

  const cancelSelling = () => {
    openConfirmation({
      handleAgree: () => {
        dispatch(unsellProduct(userId, selectedItem.id));
        closeConfirmation();
      },
      title: 'Cancel selling?',
      desc: 'Are you sure to cancel your selling. You cannot undone this process!',
      confirmText: 'Confirm',
    });
  };

  useEffect(() => {
    if (canceled) {
      navigate(-1);
    }
  }, [canceled]);

  useEffect(() => {
    if (newWatchlist) {
      openAlert({
        title: 'Bid added to watchlist',
        message: 'We will inform your watchlist bid progress!',
      });
      setOpenWatchlist(false);
    }
  }, [newWatchlist]);

  const handleAddWatchlist = () => {
    if (!subscriber) {
      openConfirmation({
        handleAgree: () => {
          navigate(ROUTES.subscription());
        },
        title: 'Explore rare wines, add to watchlist now!',
        desc: 'Subscribe to unlock the experience',
        confirmText: 'Subscribe now',
      });
      return;
    }

    if (Number(bidField || 0) > maxBid) {
      const body = {
        auction_id: selectedItem.auction?.id,
        increment_bid: 1,
        max_bid: Number(bidField),
      };
      dispatch(addToWatchlist(userId, body));
      toggleOpenWatchlist();
    }
  };

  useEffect(() => {
    if (error || detailsError) {
      setCartLoad(false);
      if (error === 401 || error === 403) return;
      openAlert({
        open: true,
        title: 'Something went wrong.',
        message,
        severity: 'error',
      });
    }

    if (checkedOut) {
      openAlert({
        open: true,
        message: 'You will redirect to payment portal',
        severity: 'success',
      });
      setWantToBuy(false);
    }
  }, [error, checkedOut, detailsError]);

  useEffect(() => {
    if (addedToCart) {
      openAlert({
        open: true,
        message: 'Item added to cart',
        severity: 'success',
      });
      dispatch(getCart(userData.id));
    }
  }, [addedToCart]);

  const checkStorageIsEnough = () => {
    if (quota <= 0 || !quota) {
      toggleWantToBuy();

      openConfirmation({
        handleAgree: () => {
          navigate(ROUTES.extraStorage());
        },
        title: 'Running out of storage',
        desc: 'You need to get extra storage before buying for a product/item',
        confirmText: 'Extra Storage',
      });

      return false;
    }
    return true;
  };

  const handleBuyItem = () => {
    const enoughStorage = checkStorageIsEnough();
    if (enoughStorage) {
      dispatch(checkoutItems(user.id, { items: [productId] }));
    }
    // dispatch(checkoutItem(user.id, productId));
  };

  const handlePayItem = () => {
    const enoughStorage = checkStorageIsEnough();
    if (enoughStorage) {
      dispatch(checkoutItemWinner(user.id, productId));
    }
  };

  const handleAddToCart = async () => {
    setCartLoad(true);
    await dispatch(addToCart(userId, { item: selectedItem.id }));
    setCartLoad(false);
  };

  const handleAddReminder = async () => {
    if (!selectedItem.reminder) {
      const body = {
        user_id: userId,
        auction_id: selectedItem.auction?.id,
        reminder_at: moment(selectedItem?.auction?.end_date).subtract(30, 'minutes').toISOString(),
        reminder_at_count: 1,
      };
      await dispatch(addReminder(userId, body));
      openAlert({
        open: true,
        title: 'Bid reminder on',
        message: 'We will inform you 30 minutes before bid ends!',
        severity: 'success',
      });
    }
  };

  const ownItem = selectedItem.owner?.id === user.id;
  const bidWinner = selectedItem.auction && selectedItem.auction?.winner === user.id;
  const auctionEnd = new Date(selectedItem?.auction?.end_date) < new Date();

  const renderAction = () => {
    if (ownItem && selectedItem.is_sale) {
      return (
        <Button fullWidth size="large" variant="outlined" className="btn-outlined" onClick={cancelSelling}>
          {t('productDetails.cancelSale')}
        </Button>
      );
    }

    if (ownItem && !selectedItem.is_sale) {
      return (
        <Button fullWidth size="large" variant="contained" className="btn-contained" onClick={() => navigate(ROUTES.sellProduct(), { state: selectedItem })}>
          Sell item
        </Button>
      );
    }

    if (bidWinner) {
      return (
        <Button fullWidth size="large" variant="contained" className="btn-contained" onClick={handlePayItem}>
          {t('productDetails.pay')}
        </Button>
      );
    }

    if (fixedPrice) {
      return (
        <Box className="floating-action">
          <Container>
            {
              !userData.subscription ? <Button className="btn-contained" fullWidth onClick={() => navigate(ROUTES.subscriptionPackage())}>{t('subs.see')}</Button> : (
                <Box display="flex" gap={1}>
                  <Button variant="outlined" className="btn-outlined" fullWidth onClick={toggleWantToBuy}>{t('productDetails.buy')}</Button>
                  <Button variant="contained" className="btn-contained" fullWidth onClick={handleAddToCart} disabled={cartLoad} startIcon={cartLoad && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <img src={Images.Market} height="20" width="20" alt="cart" />
                      <Box>{t('productDetails.addToCart')}</Box>
                    </Box>
                  </Button>
                </Box>
              )
            }
          </Container>
        </Box>
      );
    }

    if (bidPrice && !auctionEnd) {
      return (
        <Box className="floating-action">
          {
            !userData.subscription ? (
              <Container>
                <Button className="btn-contained" fullWidth onClick={() => navigate(ROUTES.subscriptionPackage())}>{t('subs.see')}</Button>
              </Container>
            )
              : (
                <Container>
                  <Button variant="contained" className="btn-contained" fullWidth onClick={toggleOpenOffer} disabled={auctionEnd}>
                    {t('productDetails.makeOffer')}
                  </Button>
                  <Button variant="outlined" className="btn-outlined" fullWidth sx={{ mt: 1.5 }} onClick={toggleOpenWatchlist} disabled={auctionEnd || selectedItem.is_watched}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <img src={MarketIcons.PeopleRed} height="20" width="20" alt="cart" />
                      <Box>{selectedItem.is_watched ? 'Added to watchlist' : t('productDetails.addToWatchlist')}</Box>
                    </Box>
                  </Button>
                </Container>
              )
          }
        </Box>
      );
    }

    return null;
  };

  return (
    <Elements.PageBase noNav>
      <div className={`${classes.root} no-scrollbar`}>
        <Box
          display="flex"
          className="sticky"
          justifyContent="space-between"
          alignItems="center"
          gap={1.5}
          py={1}
          px={2}
          border="1px solid #E5E5E5"
          borderTop="none"
          bgcolor="white"
        >
          <IconButton sx={{ p: 0 }} onClick={() => navigate(-1)}>
            <ArrowBackRounded sx={{ color: '#2E3C40' }} />
          </IconButton>
          <TextField
            InputProps={{
              startAdornment: (<SearchRounded className="mute" sx={{ mr: 1 }} fontSize="small" />),
            }}
            fullWidth
            placeholder={t('marketPage.search')}
            size="small"
          />
          {
            cart && cart.length > 0 ? (
              <Box position="relative">
                <IconButton sx={{ p: 0 }} onClick={() => navigate(ROUTES.cart())}>
                  <img src={Images.MarketBlack} height="20" width="20" alt="cart" />
                </IconButton>
                <Box
                  className="s-6 weight-700 white flex flex-center align-items-center"
                  borderRadius="50%"
                  bgcolor="#004C3B"
                  width="10px"
                  height="10px"
                  position="absolute"
                  top="0"
                  right="0"
                >
                  {cart.length}
                </Box>
              </Box>
            )
              : (
                <IconButton
                  disabled={!userData.subscription}
                  sx={{ p: 0 }}
                  onClick={() => navigate(ROUTES.cart())}
                >
                  <img src={Images.MarketBlack} height="20" width="20" alt="cart" />
                </IconButton>
              )
          }
        </Box>

        <Box textAlign="center" pt={2}>
          <img
            alt="wine"
            className="cover rounded"
            style={{
              width: '80%',
            }}
            src={selectedItem.photo || dummy.img}
          />
        </Box>
        <Divider sx={{ borderColor: '#F5F6F8', borderWidth: 4, my: 2 }} />
        <Container>
          {!!fixedPrice
            && (
              <Box className="s-16 weight-700" textAlign="center">
                <Box>
                  {selectedItem.name}
                </Box>
                <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                  <Box className="primary-green s-16 weight-700">
                    {formatNumToCurrency(selectedItem.price)}
                  </Box>
                  <Box className="s-10 weight-600">
                    {formatNumToCurrency((1000 / volume) * selectedItem.price)}
                    /l
                  </Box>
                </Box>
              </Box>
            )}
          {!!bidPrice
            && (
              <Box>
                <Box className="s-16 weight-700">
                  {selectedItem.name}
                </Box>
                <Box display="flex" alignItems="flex-end" gap={1}>
                  <Box className="s-12 weight-700">
                    {formatNumToCurrency(Number(selectedItem.price))}
                  </Box>
                  <Box className="s-10 weight-400" color="#586479">
                    {formatNumToCurrency((1000 / volume)
                    * selectedItem.price)}
                    /l
                  </Box>
                  <Box className="s-12 weight-400" color="#586479">{t('productDetails.startPrice')}</Box>
                </Box>
                <Box display="flex" justifyContent="space-between" mt={2}>
                  <Box display="flex" alignItems="center" gap={0.5} color={Colors.primary} className="s-16 weight-700">
                    <Box>
                      ₣
                      {maxBid}
                    </Box>
                    <Box className="weight-400" fontSize={10} color="#404852">{t('productDetails.highestBid')}</Box>
                  </Box>
                  <Box className="s-14 weight-400" color="#2E3C40" alignItems="center" display="flex">
                    5
                    {' '}
                    <Box display="inline-block" fontSize={10} color="#404852">{t('productDetails.watchers')}</Box>
                  </Box>
                </Box>

                <Box display="flex" gap={2} mt={1} justifyContent="space-between">
                  <Box display="flex" gap={2}>
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <PeopleOutlineOutlined sx={{ fontSize: 16, color: '#404852' }} />
                      <Box className="weight-400" fontSize={12} color="#404852">
                        {latestBid.length}
                        {' '}
                        {t('productDetails.bidder')}
                      </Box>
                    </Box>
                    <Box alignItems="center" display={auctionEnd ? 'none' : 'flex'} gap={0.5}>
                      <AccessTimeRounded sx={{ fontSize: 16, color: '#404852' }} />
                      <Box fontWeight="400" fontSize={12} color="#404852">
                        end
                        {' '}
                        {moment(selectedItem?.auction?.end_date).fromNow()}
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    border="1px solid"
                    borderColor={selectedItem.reminder ? '#DBF9DB' : '#E5E5E5'}
                    bgcolor={selectedItem.reminder ? '#DBF9DB' : 'transparent'}
                    fontWeight={selectedItem.reminder ? '700' : '400'}
                    py="4px"
                    px="8px"
                    borderRadius={1}
                    display={auctionEnd ? 'none' : 'flex'}
                    gap={0.5}
                    onClick={handleAddReminder}
                    className="link"
                  >
                    <NotificationsNoneRounded sx={{ color: selectedItem.reminder ? '#38AC3D' : '#404852', fontSize: 16 }} />
                    <Box color={selectedItem.reminder ? '#38AC3D' : '#404852'} fontSize={12}>
                      {selectedItem.reminder ? 'Reminder on' : 'Set Reminder'}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          <Box display="flex" mt={1}>
            <Box flex={1}>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.category')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">{selectedItem.category_name}</Box>
              </Box>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.origin')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">-</Box>
              </Box>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('marketPage.qty')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">1 bottle</Box>
              </Box>
            </Box>
            <Box flex={1}>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.conditions')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">{selectedItem.condition_name}</Box>
              </Box>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.volume')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">
                  {selectedItem.volume}
                </Box>
              </Box>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.inCellar')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">{moment(selectedItem?.auction?.start_date || selectedItem.marketed_on).format('DD MMM YYYY')}</Box>
              </Box>
            </Box>
            <Box flex={1}>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.year')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">{selectedItem.year}</Box>
              </Box>
              <Box mt={1.5}>
                <Box className="s-10" fontWeight="400">{t('productDetails.alcohol')}</Box>
                <Box mt={0.25} className="s-12" fontWeight="700">-</Box>
              </Box>
            </Box>
          </Box>
        </Container>
        <Divider sx={{ borderColor: '#F5F6F8', borderWidth: 4, my: 2 }} />
        <Container>
          <Box className="s-14" fontWeight="700">{t('productDetails.desc')}</Box>
          <Box className="s-12" fontWeight="400">
            {selectedItem?.description || '-'}
          </Box>
          <Box display="flex">
            <Box mt={1.5} flex={1.5}>
              <Box className="s-10" fontWeight="400">{t('productDetails.seller')}</Box>
              <Box mt={0.25} className="s-12" fontWeight="700">
                {selectedItem.owner?.front_name || 'OenoBank'}
              </Box>
            </Box>
            <Box mt={1.5} flex={1}>
              <Box className="s-10" fontWeight="400">{t('productDetails.memberSince')}</Box>
              <Box mt={0.25} className="s-12" fontWeight="700">{moment(selectedItem.owner?.created_at).format('DD MMM YYYY')}</Box>
            </Box>
            <Box mt={1.5} flex={1}>
              <Box className="s-10" fontWeight="400">{t('productDetails.wineStatus')}</Box>
              <Box mt={0.25}>
                <Box display="inline-flex" alignItems="center" gap={0.5} bgcolor="#FDE0E0" borderRadius={8} pr={1}>
                  <img src={Images.CheckRed} alt="check-icon" />
                  <div className="s-10 weight-600">Verified</div>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="s-10" fontWeight="400">{t('productDetails.notes')}</Box>
          <Box mt={0.25} className="s-12" fontWeight="600">
            {selectedItem.notes || '-'}
          </Box>
        </Container>
        <Divider sx={{ borderColor: '#F5F6F8', borderWidth: 4, my: 2 }} />
        {!!bidPrice
        && (
        <Container>
          <Box className="s-14" fontWeight="700">{t('productDetails.bidHistories')}</Box>
          {latestBid?.map((bid) => (
            <Box key={bid.price} mt={1.5} pb={1} borderBottom="1px solid #E5E5E5" display="flex">
              <Box flex={1}>
                <Box color="#586479" fontSize={12}>{t('productDetails.bidPrice')}</Box>
                <Box color="#2E3C40" fontSize={12} fontWeight="600">
                  {formatNumToCurrency(Number(bid.price))}
                </Box>
              </Box>
              <Box flex={1}>
                <Box color="#586479" fontSize={12}>{t('productDetails.dateTime')}</Box>
                <Box color="#2E3C40" fontSize={12} fontWeight="600">
                  {moment(bid.created_at).fromNow()}
                </Box>
              </Box>
              <Box flex={1}>
                <Box color="#586479" fontSize={12}>{t('productDetails.customer')}</Box>
                <Box color="#2E3C40" fontSize={12} fontWeight="600">
                  {bid.user?.front_name}
                </Box>
              </Box>
            </Box>
          ))}
        </Container>
        )}
        <Box mt={2}>
          {renderAction()}
        </Box>
      </div>

      <Elements.ConfirmationModal
        open={wantToBuy}
        desc={(
          <div>{t('productDetails.buyConfirmation')}</div>
        )}
        handleClose={toggleWantToBuy}
        handleAgree={handleBuyItem}
        isLoading={isLoading}
      />

      {/* Make an offer / Bid */}
      <Drawer
        anchor="bottom"
        open={openOffer}
        onClose={toggleOpenOffer}
      >
        <Container maxWidth="xs" sx={{ py: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box fontWeight="700" className="s-16">Make an offer</Box>
            <IconButton sx={{ p: 0 }} onClick={toggleOpenOffer}>
              <CloseRounded fontSize="small" />
            </IconButton>
          </Box>
          <Box fontWeight="400" mt={1.5}>{t('productDetails.makeOfferDesc')}</Box>
          <TextField
            fullWidth
            size="small"
            value={bidField}
            onChange={({ target }) => setBidField(onlyNumbers(target.value))}
            InputProps={{
              startAdornment: '$',
            }}
            inputProps={{ min: 0, style: { textAlign: 'right' } }}
            sx={{ mt: 1.5 }}
          />
          <Box mt={1.5} display="flex" justifyContent="space-between" gap={1}>
            {[1, 5, 10, 20].map((val) => (
              <Box
                key={val}
                flex={1}
                display="flex"
                justifyContent="space-between"
                className="s-16"
                fontWeight="700"
                py={0.5}
                px={1.5}
                border="1px solid #004C3B"
                borderRadius="10px"
                sx={{ cursor: 'pointer' }}
                onClick={() => setBidField(Number(bidField || 0) + val)}
              >
                <Box>+</Box>
                <Box>
                  ₣
                  {val}
                </Box>
              </Box>
            ))}
          </Box>
          <Button
            variant="contained"
            className="btn-contained"
            fullWidth
            sx={{ mt: 1.5 }}
            onClick={postBid}
            disabled={cartLoad || new Date(selectedItem?.auction?.end_date) < new Date()}
            startIcon={cartLoad && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}
          >
            {t('productDetails.makeOffer')}
          </Button>
        </Container>
      </Drawer>

      {/* Make an offer / Watchlist */}
      <Drawer
        anchor="bottom"
        open={openWatchlist}
        onClose={toggleOpenWatchlist}
      >
        <Container maxWidth="xs" sx={{ py: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box fontWeight="700" className="s-16">Set bid watchlist</Box>
            <IconButton sx={{ p: 0 }} onClick={toggleOpenWatchlist}>
              <CloseRounded fontSize="small" />
            </IconButton>
          </Box>
          <Box display="flex" justifyContent="space-between" mt={1.5}>
            <Box>
              {t('productDetails.currentBid')}
              {' '}
              <strong>
                ₣
                {maxBid}
              </strong>
            </Box>
            <Box>
              {latestBid.length}
              {' '}
              bids
            </Box>
          </Box>
          <Box fontWeight="400" mt={1.5}>{t('productDetails.setBid')}</Box>
          <TextField
            fullWidth
            size="small"
            value={bidField}
            onChange={({ target }) => setBidField(onlyNumbers(target.value))}
            InputProps={{
              startAdornment: '$',
            }}
            inputProps={{ min: 0, style: { textAlign: 'right' } }}
            sx={{ mt: 1 }}
          />
          <Box fontWeight="400" mt={1.5}>{t('productDetails.setMultipleBid')}</Box>
          <Box mt={1} display="flex" justifyContent="space-between" gap={1}>
            {[1, 5, 10, 20].map((val) => (
              <Box
                key={val}
                flex={1}
                display="flex"
                justifyContent="space-between"
                className="s-16"
                fontWeight="700"
                py={0.5}
                px={1.5}
                border="1px solid #004C3B"
                borderRadius="10px"
                sx={{ cursor: 'pointer' }}
                onClick={() => setBidField(Number(bidField || 0) + val)}
              >
                <Box>+</Box>
                <Box>
                  ₣
                  {val}
                </Box>
              </Box>
            ))}
          </Box>
          <Button
            variant="contained"
            className="btn-contained"
            fullWidth
            sx={{ mt: 1.5 }}
            onClick={handleAddWatchlist}
            disabled={loadingWatchlist}
            startIcon={loadingWatchlist && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}
          >
            {t('productDetails.addToWatchlist')}
          </Button>
        </Container>
      </Drawer>
    </Elements.PageBase>
  );
}
